




import _ from 'lodash';
import { computed, defineComponent } from '@vue/composition-api';
import LinkShareDialog from '@/renderer/components/dialog/linkShare/components/linkShareDialog.vue';
import LinkShareDrawer from '@/renderer/components/dialog/linkShare/components/LinkShareDrawer.vue';
export default defineComponent({
  components: {
    LinkShareDialog,
    LinkShareDrawer,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    linkData: {
      required: false,
      type: Object,
      default: null,
    },
    viewData: {
      required: false,
      type: Object,
      default: null,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    return {
      innerShow,
    };
  },
});
